import React from 'react';
// icons
import { MdErrorOutline } from 'react-icons/md';

import styled from 'styled-components';

// constants
import aampeTheme from '../../constants/aampeTheme';

interface ErrorProps {
    errorMsg: string;
    className?: string;
}

const AuthError: React.FC<React.PropsWithChildren<ErrorProps>> = ({
    errorMsg,
    className,
}) => {
    if (!errorMsg) return null;

    return (
        <Container className={className}>
            <StyledIcon />
            {errorMsg}
        </Container>
    );
};

export default AuthError;

const Container = styled.div({
    border: `1px solid ${aampeTheme.colors.error500}`,
    borderRadius: aampeTheme.borderRadius.default,
    backgroundColor: aampeTheme.colors.error50,
    color: aampeTheme.colors.error500,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginBottom: aampeTheme.spacing(3),
    marginTop: aampeTheme.spacing(-1),
    height: '52px',
});

const StyledIcon = styled(MdErrorOutline)`
    margin: ${aampeTheme.spacing(0, 2)};
`;
